/**
 *  @module WellBeingPill
 *  @overview A pill showing text and an optional icon
 */

import Icon, { IconPropsType } from '../../general/icon/icon';
import classNames from 'classnames';
import styles from './pill.module.scss';
import some from 'lodash/some';

export type WellBeingPillProps = {
  clickable?: boolean;
  isActive?: boolean;
  isLoading?: boolean;
  isRound?: boolean;
  label?: React.ReactNode;
  labelStyle?: any;
  labelClassName?: string;
  icon?: IconPropsType['icon'];
  iconColor?: string;
  iconContainerStyle?: any; // contextStyle type,
  iconPosition?: 'left' | 'right' | 'top' | 'bottom';
  iconRotation?: 'upside-down' | 'straight-up';
  padded?: boolean;
  type?:
    | 'primary'
    | 'outline'
    | 'gold'
    | 'secondary'
    | 'negative'
    | 'outline-blue'
    | 'outline-white';
  pillStyle?: any; // contextStyle Type,
  pillClassName?: string;
  className?: string;
  disabled?: boolean;
  size?: 'large' | 'medium';
};

const WellBeingPill = ({
  clickable,
  icon,
  iconColor,
  iconPosition = 'left',
  iconRotation = 'straight-up',
  iconContainerStyle,
  label,
  labelStyle,
  labelClassName,
  padded,
  isActive,
  isLoading,
  isRound = true,
  pillStyle,
  pillClassName,
  type = 'primary',
  className,
  disabled,
  size,
}: WellBeingPillProps) => {
  const PillIcon = () =>
    icon ? (
      <Icon
        icon={icon}
        height={15}
        width={15}
        color={iconColor}
        containerStyle={iconContainerStyle}
        className={classNames(
          styles.icon,
          styles[`icon--${iconPosition}`],
          styles[`icon--${iconRotation}`],
        )}
      />
    ) : null;

  const PillLabel = () => (
    <span
      className={classNames(
        styles.label,
        className,
        labelClassName && styles[labelClassName],
        type && styles[`label--${type}`],
        disabled && styles[`pill--disabled`],
        iconPosition && styles[`label--${iconPosition}`],
      )}
      style={context.handleStyle(labelStyle)}
    >
      {label}
    </span>
  );

  const Spinner = () => (
    <img
      className={styles.spinner}
      src={
        type && ['primary', 'outline-white'].indexOf(type) > -1
          ? require('../../../assets/indeterminate-spinner-light.png')
          : require('../../../assets/indeterminate-spinner.png')
      }
    />
  );

  return (
    <div
      className={classNames(
        styles.pill,
        className,
        pillClassName && styles[pillClassName],
        isRound && styles['pill--round'],
        type && styles[`pill--${type}`],
        disabled && styles[`pill--disabled`],
        padded && styles['pill--padded'],
        size && styles[`pill--${size}`],
        clickable && styles['pill--clickable'],
        isActive && styles[`active--${type}`],
      )}
      style={context.handleStyle(pillStyle)}
    >
      {isLoading ? (
        <Spinner />
      ) : // if left or top render Icon first
      some(['left', 'top'], e => e === iconPosition) ? (
        <div>
          <PillIcon />
          <PillLabel />
        </div>
      ) : (
        <div>
          <PillLabel />
          <PillIcon />
        </div>
      )}
    </div>
  );
};

WellBeingPill.displayName = 'WellBeingPill';
export default WellBeingPill;
